import { PaymentDetail } from "Components/Merchant/InitiatePaymentDetail/PaymentDetail";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";

type Props = {
  transactionPublicID: string;
};

export const InitiatePaymentDetail = ({ transactionPublicID }: Props) => (
  <PrimaryPaper
    sx={{
      pt: [8, 12],
      pb: [4, 10],
      height: "100%",
      display: "flex",
      flexDirection: "column",
      minHeight: ["88vh", "100%"],
    }}
  >
    <PaymentDetail transactionPublicID={transactionPublicID} />
  </PrimaryPaper>
);
